import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
//import { SlickCarouselModule } from 'ngx-slick-carousel';
import { CountUpModule } from 'ngx-countup';

import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { SharedModule } from '../../shared/shared.module';
import { BannerComponent } from './banner/banner.component';
import { BlockCtaComponent } from './block-cta/block-cta.component';
import { CounterComponent } from './counter/counter.component';
import { ContactBlockComponent } from './contact-block/contact-block.component';
import { ServicesComponent } from './services/services.component';
import { VideoComponent } from './video/video.component';
import { ProductsComponent } from './products/products.component';
import { TestimonialsComponent } from './testimonials/testimonials.component';
import { BlogsComponent } from './blogs/blogs.component';
import { AboutTextComponent } from './about-text/about-text.component';
import { TeamComponent } from './team/team.component';

import { ContactService } from 'src/app/components/helper/contact-helper.service';


@NgModule({
  declarations: [
    HomeComponent,
    BannerComponent,
    BlockCtaComponent,
    CounterComponent,
    ContactBlockComponent,
    ServicesComponent,
    VideoComponent,
    ProductsComponent,
    TestimonialsComponent,
    BlogsComponent,
    AboutTextComponent,
    TeamComponent
  ],
  imports: [
    CommonModule,
    HomeRoutingModule,
    SharedModule,
    NgbModule,
    CountUpModule,
    FormsModule
  ],
  providers: [ContactService]
})
export class HomeModule { }
